import { h, Fragment } from 'preact';
import { formatMoney } from 'utils/storefront/format-resource';

const ProductPrice = ({ product }) => {
  const isNotForSale = product?.tags?.includes('not-for-sale');
  
  if (isNotForSale) {
    return null;
  }
  
  return (
    <>
      {parseFloat(product.compareAtPriceRange.minVariantPrice.amount) > 0 && (
        <s className="text-grey-2">
          {formatMoney({
            amount: product.compareAtPriceRange.minVariantPrice.amount,
          })}
        </s>
      )}
      <span
        className={`${
          parseFloat(product.compareAtPriceRange.minVariantPrice.amount) > 0
            ? 'text-red ml-2'
            : ''
        }`}
      >
        {formatMoney(product.priceRange.minVariantPrice)}
      </span>
    </>
  );
};
export default ProductPrice;
